import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import MeetTheExplorer from "./sections/MeetTheExplorer";
import FreshStories from "./sections/FreshStories";
import TheExplorerSToolkit from "./sections/TheExplorerSToolkit";
import ExplorationStats from "./sections/ExplorationStats";
import JoinTheJourney from "./sections/JoinTheJourney";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <MeetTheExplorer />
      <FreshStories />
      <TheExplorerSToolkit />
      <ExplorationStats />
      <JoinTheJourney />
      <Footer />
    </div>;
}